// extracted by mini-css-extract-plugin
export default {"boton":"ReaccionListaScreen_boton__WGDSd","containerTable":"ReaccionListaScreen_containerTable__E2H42","subtitulo":"ReaccionListaScreen_subtitulo__eP1ML"};